import { getImg } from '@/utils/matchAsset'

export function sortRankingListByScore(rankingList = []) {
  return rankingList
    .map((item, index) => ({ item, index }))
    .sort((current, next) => {
      const scoreDifference = Number(next.item.score) - Number(current.item.score)
      return scoreDifference || current.index - next.index
    })
    .map(({ item }) => item)
}

export const matchProgressSectionData = {
  titleImage: getImg('match/pc/match/progress-title.png'),
  tabs: [
    { id: 'ranking', title: '战队排名', image: getImg('match/pc/match/progress-card-left-top.png'), imageActive: getImg('match/pc/match/progress-card-right-top.png') },
    { id: 'battle', title: '对战列表', image: getImg('match/pc/match/progress-card-right-bottom.png'), imageActive: getImg('match/pc/match/progress-card-left-bottom.png') },
  ],
  rankingHeaders: ['排名', '战队', '积分', '胜率'],
  battleModes: [
    { id: 'imperial-tomb', title: '帝王陵', image: getImg('match/pc/match/zd1.png') },
    { id: 'fox-cave', title: '狐狸洞', image: getImg('match/pc/match/zd2.png') },
    { id: 'paradise-cave', title: '极乐洞', image: '' },
    { id: 'taiji-sword-gate', title: '太极剑门', image: '' },
  ],
  rankingList: [
    { team: '友情岁月', score: 0, winRate: '' },
    { team: '晶天動地', score: 3, winRate: '' },
    { team: '友情战队', score: 0, winRate: '' },
    { team: '百鬼夜行', score: 0, winRate: '' },
    { team: '天龙北宗', score: 1, winRate: '' },
    { team: '大名楼', score: 0, winRate: '' },
    { team: '千年村', score: 0, winRate: '' },
    { team: '漠北天下', score: 3, winRate: '' },
    { team: '义薄云天', score: 3, winRate: '' },
    { team: '盘龙王朝', score: 3, winRate: '' },
    { team: '潇湘丶湘军', score: 2, winRate: '' },
    { team: '君临天下', score: 3, winRate: '' },
    { team: '雲鹤之巅', score: 0, winRate: '' },
    { team: '名将', score: 0, winRate: '' },
    { team: '龙行天下', score: 0, winRate: '' },
    { team: '天道院', score: 3, winRate: '' },
    { team: '战山河', score: 1, winRate: '' },
    { team: '龍啸皇朝', score: 3, winRate: '' },
    { team: '剑指天下', score: 3, winRate: '' },
    { team: '新神州战队', score: 3, winRate: '' },
    { team: '兄弟快乐起来', score: 3, winRate: '' },
    { team: '飞虎队', score: 0, winRate: '' },
    { team: '问鼎战队', score: 0, winRate: '' },
    { team: '游龙战队', score: 0, winRate: '' },
    { team: '為兇弟而戰', score: 0, winRate: '' },
    { team: '墨染千年', score: 2, winRate: '' },
    { team: '霸主战队', score: 2, winRate: '' },
    { team: '枭雄战队', score: 0, winRate: '' },
    { team: '世界战队', score: 1, winRate: '' },
    { team: '盛世战队', score: 0, winRate: '' },
    { team: '王者巅峰', score: 1, winRate: '' },
    { team: '雷霆战队', score: 0, winRate: '' },
  ],
  rankingPageSize: 10,
}
